export function groupBy(collection, extractKey) {
    return collection.reduce(groupByReducer(extractKey), new Map());
}
export function groupByReducer(extractKey) {
    return (acc, value) => {
        const key = extractKey(value);
        if (!acc.has(key)) {
            acc.set(key, []);
        }
        acc.get(key).push(value);
        return acc;
    };
}
